module.exports = __webpack_public_path__ + "static/mercury-0ed3d8b88f316ff7eeabd499006ffbf4.gif";